import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props={children:ReactNode;resetKey:string};
type State={error:Error|null};

export class WorkspaceErrorBoundary extends Component<Props,State>{
  state:State={error:null};

  static getDerivedStateFromError(error:Error):State{return {error}}

  componentDidCatch(error:Error,info:ErrorInfo){
    console.error('Workspace view failed safely',error,info.componentStack);
  }

  componentDidUpdate(previous:Props){
    if(this.state.error&&previous.resetKey!==this.props.resetKey)this.setState({error:null});
  }

  render(){
    if(!this.state.error)return this.props.children;
    return <section className="workspace-recovery" role="alert">
      <div>
        <span>View recovered</span>
        <h1>This screen could not finish loading</h1>
        <p>The main navigation is still available. Open another section or retry this screen.</p>
        <button className="button primary" onClick={()=>window.location.reload()}>Retry safely</button>
      </div>
    </section>;
  }
}
